<div class="container">
	<label class="text-center text-tertiary fw-semibold w-100 my-3">
		Índice de anomalia de precipitação modificado (IAPM) - {{ periodoTitulo }}
	</label>
	<div
		*ngIf="carregando; else mapas"
		class="d-flex justify-content-center align-items-center w-100 h-50"
		style="min-height: 500px">
		<seira-loading [pageCentered]="false"></seira-loading>
	</div>
	<ng-template #mapas>
		<div
			id="mapa-legenda"
			class="row"
			*ngIf="interpolacaoIAPM; else nenhumResultado">
			<div class="col-12 mb-3 mb-lg-0 p-0">
				<div class="mapa-wrapper p-0 mx-1">
					<seira-mapa-interpolacao
						[mapaId]="'iapm'"
						[mapaNome]="''"
						[imageOpacity]="0.8"
						[interpolacao]="interpolacaoIAPM"
						[carregando]="carregando"
						[valores]="valoresIAPM">
					</seira-mapa-interpolacao>
				</div>
			</div>
		</div>
		<seira-card-info aditionalClasses="my-2" [texto]="descricaoRelatorio" />
		<p class="referencia-estudo">
			{{ referenciaEstudo }}
		</p>
		<ng-template #nenhumResultado>
			<div class="row">
				<div class="col-12">
					<seira-sem-dados />
				</div>
			</div>
		</ng-template>
	</ng-template>
</div>
